var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConvenios(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.667 25V58.3333C116.667 60.5435 117.545 62.6631 119.108 64.2259C120.671 65.7887 122.79 66.6667 125 66.6667H158.334M158.334 66.6667L116.667 25H58.3337C53.9134 25 49.6742 26.7559 46.5485 29.8816C43.4229 33.0072 41.667 37.2464 41.667 41.6667V158.333C41.667 162.754 43.4229 166.993 46.5485 170.118C49.6742 173.244 53.9134 175 58.3337 175H141.667C146.087 175 150.326 173.244 153.452 170.118C156.578 166.993 158.334 162.754 158.334 158.333V66.6667ZM100 104.133V116.667L108.334 125M66.667 116.667C66.667 125.507 70.1789 133.986 76.4301 140.237C82.6813 146.488 91.1598 150 100 150C108.841 150 117.319 146.488 123.571 140.237C129.822 133.986 133.334 125.507 133.334 116.667C133.334 107.826 129.822 99.3476 123.571 93.0964C117.319 86.8452 108.841 83.3333 100 83.3333C91.1598 83.3333 82.6813 86.8452 76.4301 93.0964C70.1789 99.3476 66.667 107.826 66.667 116.667Z",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvenios);
export default __webpack_public_path__ + "static/media/convenios.f4082d171c256ac086d52627efe260ad.svg";
export { ForwardRef as ReactComponent };